<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM9,13C9,13,7,13,7,13C7,13,7,11,7,11C7,11,9,11,9,11C9,11,9,13,9,13C9,13,9,13,9,13ZM10.93,6.48C10.79,6.8,10.58,7.12,10.31,7.45C10.31,7.45,9.25,8.83,9.25,8.83C9.13,8.98,9.01,9.12,8.97,9.25C8.93,9.38,8.88,9.55,8.88,9.77C8.88,9.77,8.88,10,8.88,10C8.88,10,7.12,10,7.12,10C7.12,10,7.12,8.88,7.12,8.88C7.12,8.88,7.17,8.37,7.33,8.17C7.33,8.17,8.4,6.73,8.4,6.73C8.62,6.47,8.75,6.24,8.84,6.05C8.93,5.86,8.96,5.67,8.96,5.47C8.96,5.17,8.86,4.92,8.68,4.72C8.5,4.53,8.24,4.44,7.92,4.44C7.59,4.44,7.33,4.54,7.14,4.73C6.95,4.92,6.81,5.19,6.74,5.54C6.71,5.65,6.64,5.69,6.54,5.68C6.54,5.68,4.84,5.43,4.84,5.43C4.72,5.42,4.68,5.35,4.7,5.24C4.82,4.42,5.16,3.77,5.73,3.3C6.3,2.82,7.05,2.58,7.98,2.58C8.45,2.58,8.88,2.65,9.27,2.8C9.66,2.95,9.99,3.14,10.27,3.39C10.55,3.64,10.76,3.94,10.92,4.28C11.07,4.63,11.14,5,11.14,5.4C11.14,5.8,11.07,6.15,10.93,6.48C10.93,6.48,10.93,6.48,10.93,6.48Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Help',
} as DefineComponent
</script>
